"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayCompSingle = void 0;
var react_1 = __importDefault(require("react"));
var Typo_1 = require("../../../Typo");
var OKELink_1 = require("../../../OKELink");
var genIcon_1 = require("../../utils/genIcon");
var genLinkOrText_1 = require("../../utils/genLinkOrText");
var styled_components_1 = require("styled-components");
var genProfileImg_1 = require("../../utils/genProfileImg");
var DisplayCompSingle = function (_a) {
    var value = _a.value, invert = _a.invert, injectComma = _a.injectComma, S = _a.S;
    var theme = (0, styled_components_1.useTheme)();
    if (!value)
        return null;
    return (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: '1rem' } },
        (0, genIcon_1.genIcon)({ icon: value === null || value === void 0 ? void 0 : value.icon, invert: invert, S: S }),
        (value === null || value === void 0 ? void 0 : value.image) && (0, genProfileImg_1.genProfileImg)(__assign(__assign({}, value), { invert: invert, theme: theme })),
        (0, genLinkOrText_1.genLinkOrText)(value, function (display, link) { return (react_1.default.createElement(Typo_1.SANS_3, { invert: invert },
            link
                ? react_1.default.createElement(OKELink_1.OKELink, { invert: invert, to: link }, display)
                : display,
            injectComma && react_1.default.createElement("span", null, ","))); }, { invert: invert })));
};
exports.DisplayCompSingle = DisplayCompSingle;
